import BenefitIcon01 from "/public/assets/images/career/benefit/icon01.png"
import BenefitIcon02 from "/public/assets/images/career/benefit/icon02.png"
import BenefitIcon03 from "/public/assets/images/career/benefit/icon03.png"
import BenefitIcon04 from "/public/assets/images/career/benefit/icon04.png"
import BenefitIcon05 from "/public/assets/images/career/benefit/icon05.png"
import BenefitIcon06 from "/public/assets/images/career/benefit/icon06.png"
import BenefitIcon07 from "/public/assets/images/career/benefit/icon07.png"
import BenefitIcon08 from "/public/assets/images/career/benefit/icon08.png"
import BenefitIcon09 from "/public/assets/images/career/benefit/icon09.png"
import BenefitIcon10 from "/public/assets/images/career/benefit/icon10.png"
import BenefitIcon11 from "/public/assets/images/career/benefit/icon11.png"
import BenefitIcon12 from "/public/assets/images/career/benefit/icon12.png"

export const BENEFIT_ITEMS = [
    {
        items: [
            {
                imageItem: BenefitIcon01?.src,
                infoTitle: "조기퇴근",
                infoCont: "매주 금요일, 설레는 주말을 조금 더 일찍!",
                desc: "한 주 동안 수고한 직원들에게 여유로운 금요일 오후를 보내며 재충전의 시간을 부여합니다. 가족, 친구와 함께 또는 온전히 혼자만을 위한 시간을 선물합니다."
            },
            {
                imageItem: BenefitIcon02?.src,
                infoTitle: "카페테리아 무료 운영",
                infoCont: "향긋한 커피와 든든한 간식, 언제든 에너지 UP!",
                desc: "업무 중 잠깐의 휴식, 혹은 동료와의 즐거운 대화가 필요할 때, 웅비의 카페테리아에서 음료와 간식을 마음껏 즐기며 에너지를 충전할 수 있습니다."
            },
        ]
    },
    {
        items: [
            {
                imageItem: BenefitIcon03?.src,
                infoTitle: "하계휴가비 지원",
                infoCont: "열심히 일한 당신, 시원하게 떠나라!",
                desc: "뜨거운 여름, 재충전을 위한 달콤한 휴가를 계획할 수 있도록 웅비가 두둑한 휴가비를 지원합니다. 잊지 못할 추억을 만드세요!"
            },
            {
                imageItem: BenefitIcon04?.src,
                infoTitle: "명절격려금 지원",
                infoCont: "풍요로운 명절, 따뜻한 마음을 나눕니다!",
                desc: "가족 친지들과 함께 정을 나누는 행복한 명절, 넉넉한 격려금으로 감사의 마음을 전하며 풍성한 시간을 보낼 수 있도록 지원합니다."
            },
        ]
    },
    {
        items: [
            {
                imageItem: BenefitIcon05?.src,
                infoTitle: "통신비 지원",
                infoCont: "매월 생활비 부담, 조금이나마 덜어드립니다!",
                desc: "일상에 꼭 필요한 통신비, 웅비가 지원하여 당신의 가계에 작은 보탬이 되고자 합니다. 소소하지만 확실한 행복을 챙기세요."
            },
            {
                imageItem: BenefitIcon06?.src,
                infoTitle: "자기계발비 지원",
                infoCont: "멈추지 않는 열정, 배움의 즐거움을 지원합니다!",
                desc: "운동으로 건강을 다지고, 새로운 언어를 배우거나, 직무 역량을 한층 끌어올리는 등 당신의 모든 성장을 위한 투자를 웅비가 함께합니다."
            },
        ]
    },
    {
        items: [
            {
                imageItem: BenefitIcon07?.src,
                infoTitle: "건강검진 지원",
                infoCont: "건강한 삶이 최고의 복지! 온 가족 건강 지킴이!",
                desc: "직원 및 가족의 건강은 무엇과도 바꿀 수 없는 가치입니다. \n 매년 세심한 건강검진 지원으로 질병을 예방하고 활기찬 삶을 유지할 수 있도록 지원합니다."
            },
            {
                imageItem: BenefitIcon08?.src,
                infoTitle: "자녀학자금 지원",
                infoCont: "자녀의 빛나는 미래, 웅비가 함께 응원합니다!",
                desc: "초등학교부터 대학교까지, 자녀 교육에 대한 부담을 덜어드리고 오롯이 꿈을 향해 나아갈 수 있도록 웅비가 든든한 버팀목이 됩니다."
            },
        ]
    },
    {
        items: [
            {
                imageItem: BenefitIcon09?.src,
                infoTitle: "생일선물",
                infoCont: "생일, 당신의 가장 특별한 날을 축복합니다!",
                desc: "일 년 중 가장 소중한 날, 웅비가 축하와 감사의 마음을 담아 선물과 함께 조기퇴근을 지원합니다. 사랑하는 사람들과 행복한 하루를 만끽하세요."
            },
            {
                imageItem: BenefitIcon10?.src,
                infoTitle: "차량 및 유류비 지원(영업직)",
                infoCont: "현장을 누비는 당신의 발걸음을 가볍게!",
                desc: "고객을 향한 당신의 뜨거운 열정과 프로페셔널한 업무 수행을 위해, 웅비가 든든한 이동 수단과 유류비를 지원하여 최상의 성과를 만들 수 있도록 지원합니다."
            },
        ]
    },
    {
        items: [
            {
                imageItem: BenefitIcon11?.src,
                infoTitle: "휴양시설 할인 지원",
                infoCont: "최고의 휴식, 특별한 경험을 선물합니다!",
                desc: "소노호텔&리조트에서의 품격 있는 휴식을 통해 일상의 피로를 풀고, 사랑하는 사람들과 소중한 시간을 보낼 수 있도록 지원합니다."
            },
            {
                imageItem: BenefitIcon12?.src,
                infoTitle: "장기근속 포상",
                infoCont: "함께 걸어온 빛나는 시간, 진심으로 감사합니다!",
                desc: "웅비의 성장에 기여한 당신의 귀한 시간과 헌신을 잊지 않습니다. \n근속 5년시 마다 감사의 마음을 담아 특별 포상으로 그 노고에 보답합니다.\n 웅비에서의 하루하루가 직원들의 자부심이자 행복이 되기를 바랍니다."
            },
        ]
    },
]